import { createApis } from 'saga-slice-helpers';
import { checkForUnauthorized, returnMSTeamsApi } from './utils';
import { API_TIMEOUT } from '../../constants';

const { api } = createApis({
  baseURL: returnMSTeamsApi(),
  timeout: API_TIMEOUT,
});

api.instance.interceptors.response.use(
  (res) => res,
  async (err) => {
    return await checkForUnauthorized(err);
  },
);

api.instance.interceptors.request.use(
  (config) => {
    if (config.data) {
      return {
        ...config,
        data: JSON.parse(JSON.stringify(config.data).replaceAll('/', '')),
      };
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  },
);

export default api;
